export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_33-385c43885c933e4cbb40a647f7241a05.jpg";